export default __webpack_public_path__ + "static/media/Tracker.6f2f8562.png";